<template>
  <div class="content-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('yin-si-ce-lve') }} </div>


    <div class="privacy-content" v-html="content"></div>

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
      content: `
        <div class="privacy-section">
          <h2>Privacy Policy</h2>
          <p class="last-updated">Last Updated: ${new Date().toISOString().split('T')[0]}</p>
          
          <div class="privacy-item">
            <h3>1. Introduction</h3>
            <p>This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our digital asset trading platform. We respect your privacy and are committed to protecting your personal data. Please read this Privacy Policy carefully to understand our practices regarding your personal data.</p>
          </div>
          
          <div class="privacy-item">
            <h3>2. Information We Collect</h3>
            <p>We may collect the following types of information:</p>
            <h4>2.1 Personal Information</h4>
            <ul>
              <li><strong>Identity Information:</strong> Full name, date of birth, nationality, gender, signature, and government-issued identification.</li>
              <li><strong>Contact Information:</strong> Email address, phone number, residential address, and mailing address.</li>
              <li><strong>Financial Information:</strong> Bank account details, payment card details, and transaction history.</li>
              <li><strong>Account Information:</strong> Username, password, account preferences, and trading activity.</li>
            </ul>
            <h4>2.2 Automatically Collected Information</h4>
            <ul>
              <li><strong>Device Information:</strong> IP address, device type, browser type, operating system, and other technical information.</li>
              <li><strong>Usage Information:</strong> Access times, pages viewed, links clicked, and actions taken on our platform.</li>
              <li><strong>Location Information:</strong> General location information based on your IP address.</li>
              <li><strong>Cookies and Similar Technologies:</strong> Information collected through cookies, web beacons, and similar technologies.</li>
            </ul>
          </div>
          
          <div class="privacy-item">
            <h3>3. How We Use Your Information</h3>
            <p>We may use your information for the following purposes:</p>
            <ul>
              <li>To create and maintain your account</li>
              <li>To process transactions and provide our services</li>
              <li>To comply with legal and regulatory obligations, including KYC and AML requirements</li>
              <li>To verify your identity and prevent fraud or unauthorized access</li>
              <li>To communicate with you about your account, transactions, and our services</li>
              <li>To personalize your experience and improve our platform</li>
              <li>To analyze usage patterns and trends to enhance our services</li>
              <li>To protect our legal rights and interests</li>
            </ul>
          </div>
          
          <div class="privacy-item">
            <h3>4. How We Share Your Information</h3>
            <p>We may share your information with the following categories of recipients:</p>
            <ul>
              <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf, such as payment processing, data analysis, and customer support.</li>
              <li><strong>Business Partners:</strong> Trusted third parties who help us provide our services.</li>
              <li><strong>Legal and Regulatory Authorities:</strong> Government authorities, law enforcement agencies, courts, and regulators when required by law or to protect our rights.</li>
              <li><strong>Professional Advisors:</strong> Lawyers, auditors, bankers, and insurers who provide professional services to us.</li>
              <li><strong>Corporate Transactions:</strong> In connection with a corporate transaction, such as a merger, acquisition, or sale of assets.</li>
            </ul>
            <p>We will not sell your personal information to third parties for marketing purposes.</p>
          </div>
          
          <div class="privacy-item">
            <h3>5. Data Security</h3>
            <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
            <p>Our security measures include:</p>
            <ul>
              <li>Encryption of sensitive data</li>
              <li>Regular security assessments and penetration testing</li>
              <li>Access controls and authentication procedures</li>
              <li>Continuous monitoring of our systems for possible vulnerabilities</li>
              <li>Regular backups to prevent data loss</li>
            </ul>
          </div>
          
          <div class="privacy-item">
            <h3>6. Data Retention</h3>
            <p>We will retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements. In some circumstances, we may anonymize your personal data so that it can no longer be associated with you, in which case we may use such information without further notice to you.</p>
          </div>
          
          <div class="privacy-item">
            <h3>7. Your Rights</h3>
            <p>Depending on your location, you may have the following rights regarding your personal data:</p>
            <ul>
              <li><strong>Access:</strong> The right to request a copy of your personal data.</li>
              <li><strong>Rectification:</strong> The right to request that we correct inaccurate or incomplete personal data.</li>
              <li><strong>Erasure:</strong> The right to request that we delete your personal data in certain circumstances.</li>
              <li><strong>Restriction:</strong> The right to request that we restrict the processing of your personal data in certain circumstances.</li>
              <li><strong>Data Portability:</strong> The right to receive your personal data in a structured, commonly used, and machine-readable format.</li>
              <li><strong>Objection:</strong> The right to object to our processing of your personal data in certain circumstances.</li>
              <li><strong>Withdraw Consent:</strong> The right to withdraw consent at any time where we rely on consent to process your personal data.</li>
            </ul>
            <p>To exercise any of these rights, please contact us using the information provided at the end of this Privacy Policy.</p>
          </div>
          
          <div class="privacy-item">
            <h3>8. Cookies and Similar Technologies</h3>
            <p>We use cookies and similar technologies to collect information about your browsing activities and to provide you with a better user experience. You can set your browser to refuse all or some browser cookies, but this may affect your ability to use certain features of our platform.</p>
            <p>We use the following types of cookies:</p>
            <ul>
              <li><strong>Essential Cookies:</strong> Necessary for the operation of our platform.</li>
              <li><strong>Analytical/Performance Cookies:</strong> Allow us to recognize and count the number of visitors and to see how visitors move around our platform.</li>
              <li><strong>Functionality Cookies:</strong> Enable us to personalize content and remember your preferences.</li>
              <li><strong>Targeting Cookies:</strong> Record your visit to our platform, the pages you have visited, and the links you have followed.</li>
            </ul>
          </div>
          
          <div class="privacy-item">
            <h3>9. International Data Transfers</h3>
            <p>We may transfer your personal data to countries outside your country of residence, which may have different data protection laws. When we transfer your personal data internationally, we will take appropriate measures to ensure that your personal data receives an adequate level of protection.</p>
          </div>
          
          <div class="privacy-item">
            <h3>10. Children's Privacy</h3>
            <p>Our services are not intended for individuals under the age of 18, and we do not knowingly collect personal data from children. If we become aware that we have collected personal data from a child without verification of parental consent, we will take steps to remove that information from our servers.</p>
          </div>
          
          <div class="privacy-item">
            <h3>11. Changes to This Privacy Policy</h3>
            <p>We may update this Privacy Policy from time to time in response to changing legal, technical, or business developments. When we update our Privacy Policy, we will take appropriate measures to inform you, consistent with the significance of the changes we make.</p>
          </div>
          
          <div class="privacy-item">
            <h3>12. Contact Us</h3>
            <p>If you have any questions about this Privacy Policy or our privacy practices, please contact our Data Protection Officer at:</p>
            <p>We will respond to your request within a reasonable timeframe.</p>
          </div>
        </div>
      `
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>
<style scoped>
.privacy-content {
  padding: 15px;
  color: #333;
  line-height: 1.6;
}

.privacy-section {
  max-width: 800px;
  margin: 0 auto;
}

.privacy-section h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.last-updated {
  color: #666;
  font-style: italic;
  margin-bottom: 20px;
}

.privacy-item {
  margin-bottom: 25px;
}

.privacy-item h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.privacy-item h4 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 8px;
}

.privacy-item p {
  margin-bottom: 10px;
}

.privacy-item ul {
  padding-left: 20px;
  margin-bottom: 10px;
}

.privacy-item li {
  margin-bottom: 5px;
}
</style>